'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/promise/index.js
// module id = 346
// module chunks = 0